import * as React from "react";
import LiquorImg from "../liquor-img";
import ListButton from "./list-button";
import ProductDetails from "../product-details";
import MadeInAlberta from "../made-in-alberta";
import CONSTS from "../../consts";
import MultiOptionImage from "./MultiOptionImage";
export default class ProductItem extends React.Component {
    constructor(props) {
        super(props);
        this.setImage = (newUrl) => {
            this.setState({
                currentImageSrc: newUrl,
                imageSelected: true,
            });
        };
        this.state = {
            currentImageSrc: ``,
            imageSelected: false
        };
    }
    componentWillReceiveProps(nextProps, props) {
        if (!this.state.imageSelected) {
            this.setState({
                currentImageSrc: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${nextProps.product.SKU}.jpg`
            });
        }
    }
    render() {
        let product = this.props.product;
        const agentImages = ["-Agent1", "-Agent2", "-BrandLogo"];
        const images = [];
        if (this.props.product.SKU) {
            images.push(React.createElement(MultiOptionImage, { key: product.SKU, SKU: product.SKU, IsActive: this.state.currentImageSrc == product, setImage: this.setImage, Prefix: null }));
            for (var aImage of agentImages) {
                images.push(React.createElement(MultiOptionImage, { key: aImage, SKU: product.SKU, IsActive: this.state.currentImageSrc == product, setImage: this.setImage, Prefix: aImage }));
            }
        }
        //TODO verify sub-header and Varietal
        return (React.createElement("div", { className: "product-desc" },
            React.createElement("div", { className: "showcased-img" },
                React.createElement(LiquorImg, { src: this.state.currentImageSrc })),
            React.createElement("div", { className: "product-list" },
                React.createElement(MadeInAlberta, { madeInAlberta: product.MadeInAlberta }),
                React.createElement("h5", { className: "sub-header" }, product.AgentName),
                React.createElement("h1", { className: "header" }, product.Name),
                React.createElement("p", { className: "id" },
                    "SKU: ",
                    product.DisplaySKU),
                React.createElement("div", { className: "img-selection" }, images),
                React.createElement("div", { className: "mobile-img" },
                    React.createElement(LiquorImg, { src: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}.jpg` })),
                React.createElement("div", { className: "button-list" },
                    React.createElement("a", { href: `/Products/Stores/${product.SKU}` },
                        React.createElement("button", { className: "btn-primary btn-primary__filled" }, "Where To Buy")),
                    React.createElement(ListButton, { id: product.SKU })),
                React.createElement("p", { className: "disclaimer" }, "Please contact the store to confirm availability. A retailer may sell out of any product at any time."),
                React.createElement(ProductDetails, { product: this.props.product }))));
    }
}
;
//# sourceMappingURL=product-desc.js.map